/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prettier/prettier */
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable react-hooks/exhaustive-deps */
import moment from 'moment';
import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { icons } from '~/assets';
import Button from '~/components/button';
import CardView from '~/components/cartView';
import Container from '~/components/container';
import ContainerFlex from '~/components/containerFlex';
import Dialog from '~/components/dialog';
import Grid from '~/components/grid';
import Input, { MaskTypes } from '~/components/input';
import Layout from '~/components/layout';
import Loading from '~/components/loading';
import RadioButton from '~/components/radioButton';
import TextArea from '~/components/textarea';
import TitleApp from '~/components/title';
import useApi, { ApiMethod } from '~/hooks/useApi';
import { ConsultUserDetailReactivateResponse } from '~/services/consult/reactivate/response';
import Endpoints from '~/services/endpoints';
import Constants from '~/utils/constants';
import { useUserRole } from '~/hooks/contexts/useUserRole';
import { FormField } from '~/utils/form';

import * as Masks from '~/utils/masks';

import { currencyMask, formatCurrency } from '~/utils/masks';

import * as St from './styles';
import Bullet from '~/components/bullet';
import PasswordModal from '~/components/passwordModal';

interface IErrors {
  parecer?: string;
  limitRoot?: string;
  limitRppt30Percent?: string;
}

interface IDecision {
  cicloCobranca: number;
  zerarLimiteEmprestimo: boolean;
  reduzirLimiteCompra: boolean;
  reduzirLimiteEmprestimo: boolean;
  devolverCartao: boolean;
  regra: string;
  qtdDiasEntreCobrancas?: number;
}
interface IForm {
  idUsuarioInclusao?: string;
  idUsuarioDecisao?: string;
  cpf?: string;
  id?: string;
  nomeCliente: FormField;
  totalDebt?: FormField;
  amountReceived?: FormField;
  dataInclusao: FormField;
  parecerSolicitacao?: FormField;
  usuarioSolicitacao?: string;
  operationRecipe?: string;
  restabeleceLimite?: boolean;
  devolverCartao?: boolean;
  dividaTeuCardQuitada?: boolean;
  cadastroAtualizado?: boolean;
  reduzirLimite?: boolean;
  reduzirlimiteSaque?: boolean;
  zerarLimiteSaque?: boolean;
  totalCharge?: FormField;
  dataVencimento?: FormField;
}

interface IReactivate {
  numeroCartao?: string;
  cpf?: string;
  nomeCliente?: string;
  idUsuarioDecisao?: string;
  valorDivida: number;
  valorRecebidoAcordo: number;
  restabeleceLimite: boolean;
  zerarLimiteSaque: boolean;
  dividaTeuCardQuitada: boolean;
  cadastroAtualizado: boolean;
  reduzirlimite: boolean;
  reduzirLimiteSaque: boolean;
  diasAtraso: number;
  quantidadeCobranca: number;
  valorPrincipal: number;
  dataVencimento: string;
  decisaoReativacaoDto?: {
    regra?: string;
    cicloCobranca?: number;
    devolverCartao?: boolean;
    limiteCompra?: boolean;
    limiteEmprestimo?: boolean;
  };
}

const DetailReactivate = (): JSX.Element => {
  const [dialogMessageStatus, setDialogMessageStatus] = useState(false);
  const [dialogApproveStatus, setDialogApproveStatus] = useState(false);
  const [dialogMessageGoBack, setDialogMessageGoBack] = useState(false);
  const [dialogRefuseStatus, setDialogRefuseStatus] = useState(false);
  const [amountReceived, setAmountReceived] = useState<string>('');
  const [totalDebt, setTotalDebt] = useState(0);
  const [totalCharge, setTotalCharge] = useState(0);
  const [dialogMessage, setDialogMessage] = useState('');
  const [dialogConfirmation, setDialogConfirmation] = useState(false);
  const [confirmationText, setConfirmationText] = useState('');
  const [errorConfirmationMessage, setErrorConfirmationMessage] = useState('');
  const [modalPasswordOpen, setModalPasswordOpen] = useState<{
    open: boolean;
    type: 'reactivateCustomer' | '';
  }>({ open: false, type: '' });
  const [decision, setDecision] = useState<IDecision>({} as IDecision);
  const [parecer, setParecer] = useState('');
  const [errors, setErrors] = useState<IErrors>({} as IErrors);
  const [operationRecipe, setOperationRecipe] = useState<any>('');
  const [delayedDays, setDelayedDays] = useState(0);
  const [passwordLoading, setPasswordLoading] = useState(false);
  const history = useHistory();
  const { state } = useLocation<{
    id: string;
    cpf: string;
    numeroCartao: string;
    dataCadastro: string;
    status: string;
  }>();

  const [form, setForm] = useState<IForm>({
    nomeCliente: { name: 'nomeCliente', value: '' },
    dataInclusao: { name: 'dataInclusao', value: '' },
    totalDebt: { name: 'totalDebt', value: '' },
    parecerSolicitacao: { name: 'parecerSolicitacao', value: '' },
    amountReceived: { name: 'aumontReceived', value: '' },
    devolverCartao: true,
    dividaTeuCardQuitada: true,
    cadastroAtualizado: true,
    reduzirLimite: false,
    reduzirlimiteSaque: true,
    zerarLimiteSaque: false,
  });

  const goBack = () => history.goBack();

  const RequestUserInfo = useApi<ConsultUserDetailReactivateResponse>(
    Endpoints.consult.detailUserReactivate.replace(
      'PARAM_ID_REACTIVATE',
      state?.id,
    ),
    ApiMethod.GET,
  );

  const RequestMainValue = useApi<any>(
    Endpoints.consult.getMainValue.replace('PARAM_CPF', state?.cpf),
    ApiMethod.GET,
  );

  const RequestChargeAmounts = useApi<any>(
    Endpoints.consult.getChargeAmounts.replace('PARAM_CPF', state?.cpf),
    ApiMethod.GET,
  );

  const apiReactivateApro = useApi<any>(
    Endpoints.register.reactivateCustomer,
    ApiMethod.POST,
  );

  const apiReactivateRepro = useApi<any>(
    Endpoints.register.reactivateDecisionRepro.replace(
      'PARAM_ID_REATIVACAO',
      state?.id,
    ),
    ApiMethod.PUT,
  );

  const getUserDaysDelay = useApi<any>(
    Endpoints.consult.getUserDaysDelay.replace(
      'PARAM_NUMERO_CARTAO',
      state?.numeroCartao,
    ),
    ApiMethod.GET,
  );

  const RequestReactivateDecision = useApi<any>(
    Endpoints.consult.getReactivateDecision.replace('PARAM_CPF', state?.cpf),
    ApiMethod.GET,
  );

  // const apiCancelaCartaoExpNeg = useApi<any>(
  //   Endpoints.consult.cancelCard.replace(
  //     'PARAM_TIPO',
  //     'CANCELAMENTO_EXPERIENCIA',
  //   ),
  //   ApiMethod.POST,
  // );

  const { hasRole } = useUserRole();

  const showOptionsRule = () => hasRole('ADM');

  useEffect(() => {
    async function fetchData() {
      const responseUserDaysDelay = await getUserDaysDelay.callApi();

      if (state?.status === 'PENDENTE') {
        const responseDetail = await RequestUserInfo.callApi();

        if (responseDetail?.status === 200) {
          loadData(responseDetail?.data);

          const { data } = responseUserDaysDelay.data;
          setDelayedDays(data?.dias_em_atraso);
        }
      } else if (state?.status !== 'PENDENTE') {
        const responseChargeAmounts = await RequestChargeAmounts.callApi();

        const response = await RequestMainValue.callApi();

        if (response.status === 200) {
          loadData(response?.data);

          const { data } = responseUserDaysDelay.data;
          setDelayedDays(data?.dias_em_atraso);
        }

        if (responseChargeAmounts.status === 200) {
          setTotalCharge(responseChargeAmounts.data);
        }
      }
    }
    fetchData();
  }, []);

  const closeModalMessage = () => {
    setDialogMessageStatus(false);
    if (dialogMessageStatus) goBack();
  };

  const isParecerValid = () => {
    if (!parecer.trim().length) {
      setErrors((prev) => ({
        ...prev,
        parecer: 'Por favor informe o parecer.',
      }));

      return false;
    }
    setErrors((prev) => ({
      ...prev,
      parecer: null,
    }));
    return true;
  };

  const getReactivatePayload = (): IReactivate => {
    const payload: IReactivate = {
      numeroCartao: state?.numeroCartao,
      idUsuarioDecisao: form?.idUsuarioDecisao,
      cpf: state?.cpf,
      nomeCliente: form.nomeCliente.value,
      valorDivida: Number(form.totalDebt.value),
      valorRecebidoAcordo: Masks.currencyUnmasked(amountReceived),
      restabeleceLimite: form.devolverCartao,
      dividaTeuCardQuitada: form.dividaTeuCardQuitada,
      cadastroAtualizado: form.cadastroAtualizado,
      reduzirlimite: form.reduzirLimite,
      reduzirLimiteSaque: form.reduzirlimiteSaque,
      diasAtraso: delayedDays,
      quantidadeCobranca: totalCharge,
      valorPrincipal: totalDebt,
      dataVencimento: form?.dataVencimento?.value,
      zerarLimiteSaque: form.zerarLimiteSaque,
      decisaoReativacaoDto: {
        regra: decision?.regra,
        cicloCobranca: decision?.cicloCobranca,
        devolverCartao: decision?.devolverCartao,
        limiteCompra: form?.reduzirLimite,
        limiteEmprestimo: form?.reduzirlimiteSaque,
      },
    };

    return payload;
  };

  // const postCancelarCartaoExpNeg = () => {
  //   const payload = { cpf: state.cpf };

  //   return payload;
  // };

  const loadDecision = async (data: ConsultUserDetailReactivateResponse) => {
    const obj: IForm = {
      ...form,
      devolverCartao: data?.devolverCartao,
      reduzirLimite: data?.reduzirLimiteCompra,
      reduzirlimiteSaque: data?.reduzirLimiteEmprestimo,
      zerarLimiteSaque: data?.zerarLimiteEmprestimo,
    };

    setForm(obj);
  };

  const loadData = async (data: ConsultUserDetailReactivateResponse) => {
    const obj: IForm = {
      ...form,
      idUsuarioDecisao: localStorage.getItem(Constants.USER_ID),
      // idUsuarioInclusao: data.idUsuarioInclusao,
      nomeCliente: { ...form.nomeCliente, value: data?.nome },
      cpf: data?.cpf,
      totalDebt: { ...form.totalDebt, value: data?.valorFatura?.toString() },
      dataVencimento: { ...form.dataVencimento, value: data?.dataVencimento },
      // id: data.id,
      // restabeleceLimite: data.restabeleceLimite,
      // reduzirlimite: data.reduzirlimite,
      // reduzirlimiteSaque: data.reduzirLimiteSaque,
      // zerarLimiteSaque: data.zerarLimiteSaque,
      // dataInclusao: {
      //   ...form.dataInclusao,
      //   value: data.dataInclusao,
      //   unmasked: data.dataInclusao,
      // },
      // parecerSolicitacao: {
      //   ...form.parecerSolicitacao,
      //   value: data.parecerSolicitacao,
      // },
      // dividaTeuCardQuitada: data.dividaTeuCardQuitada,
      // cadastroAtualizado: data.cadastroAtualizado,
      // usuarioSolicitacao: data.usuarioSolicitacao,
      // amountReceived: { ...form.amountReceived, value: String(data.valorPago) },
    };

    setForm(obj);
    // setAmountReceived(data.valorPago);
    setTotalDebt(data?.valorPrincipal);
  };

  const onReactivateDecision = async () => {
    try {
      const response = await RequestReactivateDecision.callApi();
      if (response.status === 200) {
        setDecision(response?.data);
        loadDecision(response?.data);
      } else {
        setDialogMessageStatus(true);
        closeModalMessage();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const onClickApprove = async () => {
    setDialogApproveStatus(false);

    try {
      // if (form?.restabeleceLimite === false) {
      //   const payload = postCancelarCartaoExpNeg();
      //   const response = await apiCancelaCartaoExpNeg.callApi(payload);

      //   if (response.status === 200 || response.status === 204) {
      //     setDialogMessage('Cartão cancelado por motivo de EXP. NEGATIVA.');
      //     setDialogMessageGoBack(true);
      //   } else {
      //     setDialogMessage(response.mensagem);
      //     setDialogMessageGoBack(false);
      //   }
      // }

      const payload = getReactivatePayload();

      const response = await apiReactivateApro.callApi(payload);

      if (response.status === 201 || response.status === 204) {
        setDialogMessage('Reativação aprovada.');
        setDialogMessageStatus(true);
      } else {
        setDialogMessage(response.mensagem);
        setDialogMessageStatus(false);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setDialogMessageStatus(true);
    }
  };

  const onClickRefuse = async () => {
    setDialogRefuseStatus(false);
    if (!isParecerValid()) {
      return;
    }

    try {
      const payload = getReactivatePayload();

      const response = await apiReactivateRepro.callApi(payload);

      if (response.status === 200 || response.status === 204) {
        setDialogMessage('Reativação recusada.');
        setDialogMessageGoBack(true);
      } else {
        setDialogMessage(response.mensagem);
        setDialogMessageGoBack(false);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setDialogMessageStatus(true);
    }
  };

  const alphaRegex = /[a-zA-Z]/;

  const operation = (totalDebtValue, amountReceivedValue) => {
    setOperationRecipe(
      String(
        (parseFloat(amountReceivedValue) - parseFloat(totalDebtValue)).toFixed(
          2,
        ),
      ),
    );
  };

  const handleConfirmation = () => {
    if (confirmationText === 'CONFIRMA') {
      setDialogConfirmation(false);
      setModalPasswordOpen({ open: true, type: 'reactivateCustomer' });
    } else {
      setErrorConfirmationMessage(
        'Você precisa digitar exatamente CONFIRMA em caixa alta',
      );
    }
  };

  const handleChange = (e) => {
    if (alphaRegex.test(e.target.value)) return;

    const raw = e.target.value;
    const formatted = formatCurrency(raw);

    setAmountReceived(formatted);

    const total = parseFloat(form?.totalDebt?.value?.toString() || '0');
    const amountReceived = Masks.currencyUnmasked(formatted);

    operation(total.toFixed(2), amountReceived.toFixed(2));
  };

  return (
    <>
      <Loading
        status={
          apiReactivateApro.loading ||
          getUserDaysDelay.loading ||
          RequestMainValue.loading ||
          RequestChargeAmounts.loading ||
          RequestReactivateDecision.loading ||
          passwordLoading
        }
      />
      <Dialog
        icon={icons.confirmation}
        open={dialogMessageStatus}
        positiveLabel="Entendi"
        positiveAction={closeModalMessage}
        message={dialogMessage}
      />
      {/* Dialog de Confirmação - Aprovação */}
      <Dialog
        icon={icons.confirmation}
        open={dialogApproveStatus}
        negativeLabel="Cancelar"
        negativeAction={() => setDialogApproveStatus(false)}
        positiveLabel="Aprovar"
        positiveAction={onClickApprove}
        message="Você tem certeza que deseja aprovar a reativação?"
      />
      {/* Dialog de Confirmação - Reprovação */}
      <Dialog
        icon={icons.confirmation}
        open={dialogRefuseStatus}
        negativeLabel="Cancelar"
        negativeAction={() => setDialogRefuseStatus(false)}
        positiveLabel="Recusar"
        positiveAction={onClickRefuse}
        message="Você tem certeza que deseja recusar a reativação?"
      />
      <Dialog
        icon={icons.confirmation}
        open={dialogConfirmation}
        negativeLabel="Cancelar"
        negativeAction={() => setDialogConfirmation(false)}
        buttonDisabledPositive={confirmationText === ''}
        positiveLabel="Confirmar"
        positiveAction={() => handleConfirmation()}
        message="Você precisa digitar a palavra CONFIRMA em caixa alta"
      >
        <ContainerFlex marginTop={30}>
          <Input
            value={confirmationText}
            onChange={(e) => setConfirmationText(e.target.value.toUpperCase())}
            maxLength={8}
            placeholder="Digite CONFIRMA"
            errorMessage={errorConfirmationMessage}
          />
        </ContainerFlex>
      </Dialog>
      {modalPasswordOpen.type === 'reactivateCustomer' ? (
        <PasswordModal
          onClose={() => setModalPasswordOpen({ open: false, type: '' })}
          onSuccessValidation={() => onClickApprove()}
          isLoading={passwordLoading}
          setLoading={setPasswordLoading}
        />
      ) : null}
      <Container>
        <St.BoxCard>
          <ContainerFlex>
            <TitleApp>Reativar Cliente</TitleApp>
          </ContainerFlex>

          <ContainerFlex>
            <St.TitleCategory paddingLeft={26}>
              1. Dados da Solicitação
            </St.TitleCategory>
            <Grid xs={1} lg={2}>
              <ContainerFlex>
                <Grid xs={1} lg={1} gap={24}>
                  <ContainerFlex padding={26}>
                    <Input
                      label="Nome completo"
                      name={form.nomeCliente.name}
                      readOnly
                      value={form.nomeCliente.value}
                    />
                    <Input
                      label="Total de dívida do cliente"
                      name={form.totalDebt.name}
                      readOnly
                      value={currencyMask(Number(form.totalDebt.value))}
                    />
                    <Input
                      label="Valor total recebido no acordo"
                      name="amountReceived"
                      value={amountReceived}
                      inputMode="numeric"
                      placeholder="0,00"
                      edit
                      onChange={handleChange}
                    />
                    <Input
                      label="Cliente desde?"
                      name="dataCadastro"
                      readOnly
                      value={state?.dataCadastro}
                    />
                    <Input
                      label="Valor Principal"
                      name="totalDebt"
                      readOnly
                      value={currencyMask(totalDebt)}
                    />
                  </ContainerFlex>
                </Grid>
              </ContainerFlex>
              <ContainerFlex>
                <Grid xs={1} lg={1} gap={24}>
                  <ContainerFlex padding={26}>
                    <ContainerFlex>
                      <Input
                        label="CPF"
                        name="cpf"
                        mask={MaskTypes.CPF}
                        maxLength={14}
                        placeholder="000.000.000-00"
                        value={Masks.cpfMask(state?.cpf).masked}
                      />
                    </ContainerFlex>
                    <ContainerFlex>
                      <Input
                        style={{
                          color: operationRecipe < 0 ? 'red' : 'black',
                        }}
                        label="Receita da Operação"
                        name="operationRecipe"
                        value={formatCurrency(operationRecipe)}
                        readOnly
                      />
                    </ContainerFlex>
                    <ContainerFlex>
                      <Input
                        label="Dias de atraso"
                        name="cpf"
                        value={delayedDays}
                        readOnly
                      />
                    </ContainerFlex>
                    <ContainerFlex>
                      <Input
                        label="Quantidade de passagens pela CBR (incluindo a atual)?"
                        name="totalCharge"
                        readOnly
                        value={totalCharge}
                      />
                    </ContainerFlex>
                    {/* <ContainerFlex>
                      <Input
                        label="Valor total recebido no acordo"
                        name="amountReceived"
                        readOnly
                        value={currencyMask(amountReceived)}
                      />
                    </ContainerFlex> */}
                  </ContainerFlex>
                  <ContainerFlex end marginRight={20}>
                    <Button
                      disabled={!amountReceived}
                      onClick={onReactivateDecision}
                    >
                      Gravar
                    </Button>
                  </ContainerFlex>
                </Grid>
              </ContainerFlex>
            </Grid>
            <Grid xs={1} lg={2} gap={30}>
              <ContainerFlex>
                <ContainerFlex marginLeft={26}>
                  {decision &&
                    typeof decision === 'object' &&
                    Object.keys(decision).length > 0 && (
                      <ContainerFlex>
                        <St.TitleCategory
                          style={{ backgroundColor: '#fff' }}
                          paddingLeft={26}
                        >
                          2. Sugestão do sistema
                        </St.TitleCategory>
                        <ContainerFlex
                          style={{
                            boxShadow: '1px 1px 7px 0 rgba(201,201,201, 0.5',
                          }}
                          padding={20}
                          gap="20"
                        >
                          <ContainerFlex row horizontal gap="3">
                            <span>Regra:</span>
                            <span>{decision?.regra}</span>
                          </ContainerFlex>
                          <ContainerFlex row horizontal gap="3">
                            <span>Ciclo de cobrança:</span>
                            <span>{decision?.cicloCobranca}</span>
                          </ContainerFlex>
                          <ContainerFlex row horizontal gap="3">
                            <span>Devolver cartão?:</span>
                            <span>
                              {decision?.devolverCartao ? 'Sim' : 'Não'}
                            </span>
                          </ContainerFlex>
                          <ContainerFlex row horizontal gap="3">
                            <span>Limite de compras: </span>
                            <span>
                              {decision?.reduzirLimiteCompra
                                ? 'Reduzir'
                                : 'Manter'}
                            </span>
                          </ContainerFlex>
                          <ContainerFlex row horizontal gap="3">
                            <span>Limite de Empréstimo: </span>
                            <span>
                              {decision?.reduzirLimiteEmprestimo
                                ? 'Reduzir em 50%'
                                : decision.zerarLimiteEmprestimo
                                ? 'Zerar o limite de empréstimo'
                                : 'Não reduzir o limite de empréstimo'}
                            </span>
                          </ContainerFlex>
                          <ContainerFlex row horizontal gap="3">
                            <span>Quantidade de dias entre cobranças: </span>
                            <span>{decision?.qtdDiasEntreCobrancas || 0}</span>
                          </ContainerFlex>
                        </ContainerFlex>
                      </ContainerFlex>
                    )}
                </ContainerFlex>
              </ContainerFlex>
              <ContainerFlex>
                {decision &&
                  typeof decision === 'object' &&
                  Object.keys(decision).length > 0 && (
                    <>
                      <St.TitleCategory style={{ backgroundColor: '#fff' }}>
                        3. Decisão do supervisor
                      </St.TitleCategory>
                      <ContainerFlex
                        row
                        horizontal
                        style={{
                          boxShadow: '1px 1px 7px 0 rgba(201,201,201, 0.5',
                        }}
                        padding={10}
                        height={500}
                      >
                        <ContainerFlex>
                          <ContainerFlex row horizontal align="center">
                            <ContainerFlex row horizontal gap="10">
                              <Bullet
                                color={
                                  decision?.devolverCartao ===
                                  form.devolverCartao
                                    ? 'green'
                                    : 'red'
                                }
                              />
                              <St.Subtitle>Devolver cartão?</St.Subtitle>
                            </ContainerFlex>

                            <St.ContainerRadio>
                              <ContainerFlex row horizontal align="center">
                                <RadioButton
                                  checked={form?.devolverCartao === true}
                                  onChange={(e) =>
                                    setForm({ ...form, devolverCartao: true })
                                  }
                                />
                                SIM
                              </ContainerFlex>
                              <ContainerFlex row horizontal align="center">
                                <RadioButton
                                  id={form?.id}
                                  checked={form?.devolverCartao === false}
                                  onChange={(e) =>
                                    setForm({ ...form, devolverCartao: false })
                                  }
                                />
                                NÃO
                              </ContainerFlex>
                            </St.ContainerRadio>
                          </ContainerFlex>
                          <ContainerFlex row horizontal align="center">
                            <ContainerFlex row horizontal gap="10">
                              <Bullet
                                color={
                                  form.dividaTeuCardQuitada ? 'green' : 'red'
                                }
                              />
                              <St.Subtitle>
                                {' '}
                                Dívidas Teucard quitadas?
                              </St.Subtitle>
                            </ContainerFlex>
                            <St.ContainerRadio>
                              <ContainerFlex row horizontal align="center">
                                <RadioButton
                                  id={form?.id}
                                  checked={form?.dividaTeuCardQuitada === true}
                                  onChange={() =>
                                    setForm({
                                      ...form,
                                      dividaTeuCardQuitada: true,
                                    })
                                  }
                                />
                                SIM
                              </ContainerFlex>
                              <ContainerFlex row horizontal align="center">
                                <RadioButton
                                  id={form?.id}
                                  checked={form?.dividaTeuCardQuitada === false}
                                  onChange={() =>
                                    setForm({
                                      ...form,
                                      dividaTeuCardQuitada: false,
                                    })
                                  }
                                />
                                NÃO
                              </ContainerFlex>
                            </St.ContainerRadio>
                          </ContainerFlex>
                          {/* <ContainerFlex row horizontal align="center">
                            <ContainerFlex row horizontal gap="10">
                              <Bullet
                                color={
                                  form.cadastroAtualizado ? 'green' : 'red'
                                }
                              />
                              <St.Subtitle>
                                {' '}
                                Cadastro foi atualizado?
                              </St.Subtitle>
                            </ContainerFlex>
                            <St.ContainerRadio>
                              <ContainerFlex row horizontal align="center">
                                <RadioButton
                                  id={form?.id}
                                  checked={form?.cadastroAtualizado === true}
                                  onChange={() =>
                                    setForm({
                                      ...form,
                                      cadastroAtualizado: true,
                                    })
                                  }
                                />
                                SIM
                              </ContainerFlex>
                              <ContainerFlex row horizontal align="center">
                                <RadioButton
                                  id={form?.id}
                                  checked={form?.cadastroAtualizado === false}
                                  onChange={() =>
                                    setForm({
                                      ...form,
                                      cadastroAtualizado: false,
                                    })
                                  }
                                />
                                NÃO
                              </ContainerFlex>
                            </St.ContainerRadio>
                          </ContainerFlex> */}
                          <ContainerFlex row horizontal align="center">
                            <ContainerFlex row horizontal gap="10">
                              <Bullet
                                color={
                                  decision?.reduzirLimiteCompra ===
                                  form.reduzirLimite
                                    ? 'green'
                                    : 'red'
                                }
                              />
                              <St.Subtitle>
                                Reduzir o limite de compras?
                              </St.Subtitle>
                            </ContainerFlex>

                            <St.ContainerRadio>
                              <ContainerFlex row horizontal align="center">
                                <RadioButton
                                  id={form?.id}
                                  checked={form?.reduzirLimite === true}
                                  onChange={() =>
                                    setForm({ ...form, reduzirLimite: true })
                                  }
                                />
                                SIM
                              </ContainerFlex>
                              <ContainerFlex row horizontal align="center">
                                <RadioButton
                                  id={form?.id}
                                  checked={form?.reduzirLimite === false}
                                  onChange={() =>
                                    setForm({ ...form, reduzirLimite: false })
                                  }
                                />
                                NÃO
                              </ContainerFlex>
                            </St.ContainerRadio>
                          </ContainerFlex>
                          <ContainerFlex row horizontal align="center">
                            <ContainerFlex row horizontal gap="10">
                              <Bullet
                                color={
                                  decision?.reduzirLimiteEmprestimo ===
                                  form.reduzirlimiteSaque
                                    ? 'green'
                                    : 'red'
                                }
                              />
                              <St.Subtitle>
                                Reduzir o limite de empréstimo?
                              </St.Subtitle>
                            </ContainerFlex>

                            <St.ContainerRadio>
                              <ContainerFlex row horizontal align="center">
                                <RadioButton
                                  id={form?.id}
                                  checked={form?.reduzirlimiteSaque === true}
                                  onChange={() =>
                                    setForm({
                                      ...form,
                                      reduzirlimiteSaque: true,
                                    })
                                  }
                                />
                                SIM
                              </ContainerFlex>
                              <ContainerFlex row horizontal align="center">
                                <RadioButton
                                  id={form?.id}
                                  checked={form?.reduzirlimiteSaque === false}
                                  onChange={() =>
                                    setForm({
                                      ...form,
                                      reduzirlimiteSaque: false,
                                    })
                                  }
                                />
                                NÃO
                              </ContainerFlex>
                            </St.ContainerRadio>
                          </ContainerFlex>
                          <ContainerFlex row horizontal align="center">
                            <ContainerFlex row horizontal gap="10">
                              <Bullet
                                color={
                                  decision?.zerarLimiteEmprestimo ===
                                  form.zerarLimiteSaque
                                    ? 'green'
                                    : 'red'
                                }
                              />
                              <St.Subtitle>
                                Zerar limite de empréstimo?
                              </St.Subtitle>
                            </ContainerFlex>

                            <St.ContainerRadio>
                              <ContainerFlex row horizontal align="center">
                                <RadioButton
                                  id={form?.id}
                                  checked={form?.zerarLimiteSaque === true}
                                  onChange={() =>
                                    setForm({ ...form, zerarLimiteSaque: true })
                                  }
                                />
                                SIM
                              </ContainerFlex>
                              <ContainerFlex row horizontal align="center">
                                <RadioButton
                                  id={form?.id}
                                  checked={form?.zerarLimiteSaque === false}
                                  onChange={() =>
                                    setForm({
                                      ...form,
                                      zerarLimiteSaque: false,
                                    })
                                  }
                                />
                                NÃO
                              </ContainerFlex>
                            </St.ContainerRadio>
                          </ContainerFlex>
                        </ContainerFlex>
                      </ContainerFlex>
                    </>
                  )}
              </ContainerFlex>
            </Grid>

            {/* <ContainerFlex row horizontal marginLeft={26} marginTop={20}>
              <ContainerFlex
                style={{ boxShadow: '1px 1px 7px 0 rgba(201,201,201, 0.5' }}
                padding={20}
              >
                <St.TitleParecer>Data e Hora</St.TitleParecer>
                <ContainerFlex>
                  <St.TitleParecer>
                    {form.dataInclusao
                      ? moment(form?.dataInclusao.value).format(
                          'DD/MM/YYYY HH:mm',
                        )
                      : ''}
                  </St.TitleParecer>
                </ContainerFlex>
              </ContainerFlex>

              <ContainerFlex
                marginLeft={20}
                style={{ boxShadow: '1px 1px 7px 0 rgba(201,201,201, 0.5' }}
                padding={20}
              >
                <ContainerFlex>
                  <St.TitleParecer>Usuário</St.TitleParecer>
                  <St.TitleParecer>
                    {form.usuarioSolicitacao ? form.usuarioSolicitacao : '--'}
                  </St.TitleParecer>
                </ContainerFlex>
              </ContainerFlex>

              <ContainerFlex
                marginLeft={20}
                style={{ boxShadow: '1px 1px 7px 0 rgba(201,201,201, 0.5' }}
                padding={20}
                marginRight={20}
              >
                <St.TitleParecer>Parecer de Solicitação</St.TitleParecer>
                <ContainerFlex>
                  <St.TitleParecer>
                    {form.parecerSolicitacao.value
                      ? form.parecerSolicitacao.value
                      : '--'}
                  </St.TitleParecer>
                </ContainerFlex>
              </ContainerFlex>
            </ContainerFlex> */}
            <br />
            {/* <St.TitleCategory paddingLeft={26}>
              3. Decisão
              <St.TitleAbbr title="Obrigatório">*</St.TitleAbbr>
            </St.TitleCategory>
            <ContainerFlex padding={26}>
              <TextArea
                placeholder="Digitar parecer.."
                name="parecer"
                rows={10}
                value={parecer}
                onChange={(e) => setParecer(e.target.value)}
                errorMessage={errors.parecer}
                disabled={
                  form.idUsuarioInclusao !==
                  localStorage.getItem(Constants.USER_ID)
                    ? !showOptionsRule()
                    : true
                }
              />
              <div style={{ marginTop: '10px' }}>
                <St.TitleAbbrFooter>* Obrigatório preencher</St.TitleAbbrFooter>
              </div>
            </ContainerFlex> */}
          </ContainerFlex>

          {decision &&
            typeof decision === 'object' &&
            Object.keys(decision).length > 0 && (
              <ContainerFlex row horizontal marginTop={10} end>
                <Button outlined onClick={goBack}>
                  Voltar
                </Button>

                <Button
                  marginLeft={16}
                  disabled={!decision || Object.keys(decision).length === 0}
                  onClick={() => setDialogConfirmation(true)}
                >
                  Reativar
                </Button>
              </ContainerFlex>
            )}
        </St.BoxCard>
      </Container>
    </>
  );
};

export default DetailReactivate;
